import { Typography, Box, Grid } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet'

interface IProps {
  item: any
  compKey: string
  outerSubmit: any
  classes: ClassNameMap
}

const CommunicateToPatientComponent: React.FC<IProps> = ({
  classes,
}) => {
  return (
    <Box className={classes.subModalBackground}>
      <Grid spacing={1} container>
        <Grid item sm={12}>
          <Typography variant="subtitle2">
            Have you finalised and communicated the program recommendation with patient?
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default withStyles(stylesheet)(CommunicateToPatientComponent)
